import React from 'react'
import { Link } from '@shopify/polaris'

const CustomLink = props => {
  return (
    <Link {...props}>
      {props.children}
    </Link>
  )
}

export default CustomLink



// WEBPACK FOOTER //
// ./src/components/common/Link.js